import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Platform, PopoverController } from "@ionic/angular";
import { ThemeService } from "src/service/theme.service";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";

@Component({
    selector: "app-popover-multiple-commands-toolbar",
    templateUrl: "./popover-multiple-commands-toolbar.component.html",
    styleUrls: ["./popover-multiple-commands-toolbar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopoverMultipleCommandsToolbarComponent {
  @Input() buttonsToShow: Array<{ [key: string]: any }> = [];

  constructor(
    public platform: Platform,
    public popover: PopoverController,
  ) {
  }
}
